define(function (require, exports, module) {
    'use strict';

    var UploadFail = require('./UploadFail');

    /**
     * @constructor
     * @extends {UploadFail}
     * @param {Error} stack
     * @param {string} source
     */
    function UnsupportedFolderTransferFail(stack, source) {
        UploadFail.apply(this, arguments);
    }

    /**
     * @param {DOMException|FileError} error
     * @returns {boolean}
     */
    UnsupportedFolderTransferFail.isNotReadableError = function (error) {
        var isNotReadableError = false;

        if (window.DOMException && error instanceof DOMException) {
            // Chrome
            isNotReadableError = error.code === DOMException.NOT_READABLE_ERR;
        } else if (window.FileError && error instanceof FileError) {
            // Safari
            isNotReadableError = error.code === FileError.NOT_READABLE_ERR;
        }

        return isNotReadableError;
    };

    UnsupportedFolderTransferFail.prototype = Object.assign(Object.create(UploadFail.prototype), {
        constructor: UnsupportedFolderTransferFail,
        className: 'UnsupportedFolderTransferFail',
        radarName: 'fail_{SOURCE}_unsupported-folder-transfer',
        message: 'Браузер не поддерживает загрузку папок.',
    });

    module.exports = UnsupportedFolderTransferFail;
});
